<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-backgroundSecondary">
    <template #left>
      <div
        class="flex h-full items-center justify-center bg-gradient-to-b from-[#000] via-[#001220] to-primary"
        style="width: 35vw"
      >
        <img :src="Logo" alt="Logo" />
      </div>
    </template>
    <template #content>
      <main class="mx-auto flex h-full max-w-[420px] items-center justify-center">
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-backgroundSecondary">
    <template #content>
      <main class="flex h-full w-full flex-col items-center justify-center gap-8 p-8">
        <img :src="LogoAlt" alt="Logo" class="size-16" />

        <RouterView />
      </main>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'

import Logo from '@/assets/RoleDeBoa_logo_white.svg'
import LogoAlt from '@/assets/icon_black.svg'

const breakpoint = useBreakpoint()
</script>
